import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { getStoredLanguage, getTranslation } from './utils';

const defaultLanguage = getStoredLanguage();

i18n.use(initReactI18next).init({
  fallbackLng: defaultLanguage,
  interpolation: { escapeValue: false },
  lng: defaultLanguage,
  resources: {},
});

const loadTranslations = async () => {
  try {
    const storedLanguage = getStoredLanguage();
    const translation = await getTranslation(storedLanguage);
    i18n.addResourceBundle(storedLanguage, 'translation', translation);
    i18n.changeLanguage(storedLanguage);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error loading translations:', error);
  }
};

loadTranslations();

export default i18n;
